import { Box } from '@mui/material';
import { CloseIcon } from '@synergy/theme-next';
import { Form } from 'formik';
import { FormattedMessage } from 'react-intl';
import { PoolButton, PoolDrawer, PoolDrawerHeader } from '@synergy/components-next';
import { ReactElement } from 'react';
import { Stack, styled } from '@mui/material';

import { ChangePasswordContent } from './change-password-content';
import { changePasswordSelector } from '../../../store/change-password-selectors';
import { useAppSelector } from '../../../../store/store';

const StickyContainer = styled(Box)(({ theme }) => ({
    position: 'sticky',
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(2),
    bottom: 0,
}));

const StyledForm = styled(Form)(() => ({
    height: '100%',
}));

export const ChangePasswordDrawer = ({ onClose }: { onClose: () => void }): ReactElement | null => {
    const { isOpen } = useAppSelector(changePasswordSelector);

    return (
        <PoolDrawer
            open={isOpen}
            PaperProps={{
                sx: { height: '100%' },
            }}
        >
            <PoolDrawerHeader onClick={onClose}>
                <CloseIcon />
                <FormattedMessage id="app.changePassword" />
            </PoolDrawerHeader>
            <StyledForm noValidate={true}>
                <Stack justifyContent="space-between" sx={{ height: '100%' }}>
                    <Box sx={{ px: 2, pt: 2 }}>
                        <ChangePasswordContent />
                    </Box>
                    <StickyContainer>
                        <PoolButton type="submit" fullWidth={true}>
                            <FormattedMessage id="app.changePassword" />
                        </PoolButton>
                    </StickyContainer>
                </Stack>
            </StyledForm>
        </PoolDrawer>
    );
};
